import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {DischargeComponent} from './discharge.component';
import {routing} from './discharge.routing';
import {CollapseModule} from 'ngx-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {NgxPaginationModule} from 'ngx-pagination';
import {NguiAutoCompleteModule} from '@ngui/auto-complete';
import {SharedTranslationModule} from '../../shared/change-language/shared-translation.module';
import {AutoCompleteModule} from 'primeng/primeng';
import {TrnAdmissionService} from '../../configuration/trn-admission/trn-admission.service';
import {MstStaffService} from '../../configuration/mst-staff/mst-staff.service';
import {MipdDischargeDestinationService} from '../../configuration/mipd-discharge-destination/mipd-discharge-destination.service';
import {MipdAdmissionTypeService} from '../../configuration/mipd-admission-type/mipd-admission-type.service';
import {MipdDischargeTypeService} from '../../configuration/mipd-discharge-type/mipd-discharge-type.service';
import {DischargeService} from './discharge.service';
import {TrnDischargeApproveUserListService} from '../../configuration/trn-discharge-approve-user-list/trn-discharge-approve-user-list.service';
import {DateConverService} from '../../shared/custom-service/DateConvert.service';
import {DpDatePickerModule} from 'ng2-jalali-date-picker';
import {TinvPharmacySaleService} from '../../inventory/tinv-pharmacy-sale/tinv-pharmacy-sale.service';
import {Daterangepicker} from 'ng2-daterangepicker';
import {TbillBillService} from '../../billing/tbill-bill/tbill-bill.service';

@NgModule({
  imports: [
    CommonModule,
    routing,
    CollapseModule, FormsModule, HttpModule, ReactiveFormsModule, SharedTranslationModule, NguiAutoCompleteModule, NgxPaginationModule, AutoCompleteModule, DpDatePickerModule, Daterangepicker
  ],
  declarations: [DischargeComponent],
  providers: [DischargeService, TrnDischargeApproveUserListService, TrnAdmissionService, MstStaffService, MipdDischargeDestinationService, MipdAdmissionTypeService, MipdDischargeTypeService, DateConverService,
    DatePipe, TinvPharmacySaleService, TbillBillService]
})
export class DischargeModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/discharge/discharge.module.ts